import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Pagination from '../../../../features/Pagination/Pagination';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { OptionButton } from '../../../../utils/Button';
import cn from '../../../../utils/cn';
import { TableSortArrow } from '../../../../utils/IconComp';
import InstOption from '../../../../utils/InstOption';
import { GetDate, GetTime } from '../../../../utils/Show';
import { DownArrowIcon } from '../../../../utils/SVGIcon';
import { mkRelativeUrl } from '../../../../utils/URL';
import { useAgency } from '../../AgencyProvider';
import ModalAgencyCustomerStatusChange from '../Modals/ModalAgencyCustomerStatusChange';
import ModalAgencyStatusChange from '../Modals/ModalAgencyStatusChange';

function OrganizationRow({ item }) {
    if (item?.agencyId === -9191) {
        return (
            <div className="inline-flex items-center gap-1.5 w-full">
                <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium ">
                    {item?.organization || item?.fullName || '-----'}
                    {` (${item?.customerList?.length || 0})`}
                </span>
                {item?.isNew && (
                    <span className="text-xs bg-secondary-200 text-secondary px-[7px] py-0.5 rounded no-underline">
                        New
                    </span>
                )}
            </div>
        );
    }
    return (
        <div
            // onClick={() => navigate(mkRelativeUrl(`/agency/${item?.id}`))}
            className="cursor-pointer group-hover:text-secondary group/row"
        >
            <Link
                to={
                    item?.role === 'agency'
                        ? `/agency/${item?.id}/customers`
                        : `/agency/${item?.agencyId}/customers/${item?.id}/info`
                }
                className="inline-block w-full"
            >
                <div className="inline-flex items-center gap-1.5">
                    <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium group-hover/row:underline">
                        {item?.organization || item?.fullName || '-----'}
                        {!item?.agencyId && ` (${item?.customerList?.length || 0})`}
                    </span>
                    {item?.isNew && (
                        <span className="text-xs bg-secondary-200 text-secondary px-[7px] py-0.5 rounded no-underline">
                            New
                        </span>
                    )}
                </div>
            </Link>
        </div>
    );
}

function TblAgencyCustomerInfo({ customer, isActiveAgency }) {
    const [showMenu, setShowMenu] = useState(false);
    const isActive = customer?.status === 'active';
    const { openModal, setConfirm } = useTemplate();
    const { handleReload } = useAgency();
    const navigate = useNavigate();
    const handleShowInstMenu = (e) => {
        e.stopPropagation();
        setShowMenu((d) => !d);
    };

    // -- Change Customer Status Handler
    const handleAgencyStatusModal = (e, data) => {
        e.stopPropagation();
        setConfirm({
            showButton: false,
            text: <ModalAgencyCustomerStatusChange data={data} onReload={handleReload} />
        });
    };

    return (
        <tr className={cn(`group border !bg-warning/5`)}>
            <td>
                <span className="ml-6 inline-block">{customer?.id}</span>
            </td>
            <td>
                <span className="capitalize text-ellipsis overflow-hidden block">
                    {customer?.role}
                </span>
            </td>
            <td>
                <OrganizationRow item={customer} />
            </td>
            <td>
                <span className="text-ellipsis overflow-hidden w-full block">
                    {customer?.primaryEmail || '------'}
                </span>
            </td>
            <td className="hidden xl:table-cell">
                <span>
                    <div className="flex flex-row relative customer_apps h-8">
                        {customer?.subscriptions?.map((app, index) => (
                            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                            <img
                                key={app.id}
                                data-tooltip-id="myToolTip"
                                data-tooltip-content={app.subscriptionName}
                                src={app.logoUrl}
                                alt={app.name}
                                onClick={() =>
                                    navigate(mkRelativeUrl(`/subscriptions/manage/${app?.id}/info`))
                                }
                                className={`w-8 absolute top-1/2 -translate-y-1/2 rounded-full border cursor-pointer bg-white border-primary-200 app-${
                                    index + 1
                                }`}
                            />
                        ))}

                        {customer?.subscriptions?.length >= 5 && (
                            <span
                                data-tooltip-id="myToolTip"
                                data-tooltip-content={`${customer.subscriptions.length - 3} more`}
                                className="flex flex-row items-center justify-center w-8 h-8 text-white absolute top-1/2 text-sm font-medium -translate-y-1/2 left-18 rounded-full border border-white bg-[#1B1B1F]/80 cursor-pointer z-10"
                            >
                                +{customer.subscriptions.length - 3}
                            </span>
                        )}
                    </div>
                </span>
            </td>
            <td>
                <span className={customer?.timeCreated ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(customer?.timeCreated) || '--'} <br />
                    <small>{GetTime(customer?.timeCreated)}</small>
                </span>
            </td>
            <td className="text-center capitalize">
                <span className="text-center capitalize">{customer?.currency || '--'}</span>
            </td>
            <td className="text-center capitalize">
                {/* <span className={customer?.tfaEnabled ? 'text-secondary' : 'text-error'}>
                    {customer?.tfaEnabled ? 'Enabled' : 'Disabled'}
                </span> */}
            </td>
            <td className="text-center capitalize">
                <span className={isActive ? 'text-secondary' : 'text-warning'}>
                    {customer?.status}
                </span>
            </td>
            <td className="text-center !pr-5">
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowInstMenu} disabled={!isActiveAgency} />
                    {/* {console.log(customer)} */}
                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        {customer?.agencyId === -9191 ? (
                            <button
                                type="button"
                                onClick={() => openModal('move-to-under-agency', customer)}
                            >
                                Move to Under Agency
                            </button>
                        ) : null}
                        <button
                            type="button"
                            onClick={(ev) =>
                                handleAgencyStatusModal(ev, {
                                    id: customer?.id,
                                    status: customer?.status
                                })
                            }
                        >
                            {customer?.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        </button>
                        {isActive && customer?.agencyId !== -9191 && (
                            <button
                                type="button"
                                onClick={() =>
                                    openModal('CHANGE_CUSTOMER_CURRENCY_MODEL', customer)
                                }
                            >
                                Change Currency
                            </button>
                        )}
                    </InstOption>
                </div>
            </td>
        </tr>
    );
}

function TableRow({ item, setActiveId, activeId }) {
    // const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState(false);
    const { put } = useApi();
    const { setMessage, setConfirm, openModal } = useTemplate();
    const { handleReload } = useAgency();

    const handleShowInstMenu = (e) => {
        e.stopPropagation();
        setShowMenu((d) => !d);
    };

    const handleDisable2FA = (e) => {
        e.stopPropagation();
        setConfirm({
            text: 'Disabling Two-Factor Authentication will remove an additional layer of security on this account. Are you sure you want to proceed?',
            textAction: 'Yes',
            clickAction: () => {
                put(`/api/agency/${item.id}/disable-2fa`)
                    .then(({ title }) => {
                        setMessage({ type: 'success', text: title });
                        setConfirm(null);
                        handleReload();
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    // -- Change Customer Status Handler
    const handleAgencyStatusModal = (e, data) => {
        e.stopPropagation();
        setConfirm({
            showButton: false,
            text: <ModalAgencyStatusChange data={data} onReload={handleReload} />
        });
    };

    const isActive = item?.status === 'active';

    const isExpanded = activeId === item.id;

    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo,
                '!bg-warning/20 border !border-b-transparent': isExpanded
            })}
        >
            <td>
                <span className="inline-flex items-center justify-start gap-2.5">
                    <button
                        type="button"
                        onClick={() => setActiveId(isExpanded ? -1 : item.id)}
                        className={cn(`-rotate-90 transition-all duration-200`, {
                            'rotate-0': isExpanded
                        })}
                    >
                        <DownArrowIcon />
                    </button>
                    <span>{item?.id}</span>
                </span>
            </td>
            <td>
                <span className="capitalize text-ellipsis overflow-hidden block">{item?.role}</span>
            </td>
            <td>
                <OrganizationRow item={item} />
            </td>
            <td>
                <span className="text-ellipsis overflow-hidden w-full block">
                    {item?.primaryEmail || '------'}
                </span>
            </td>
            <td className="hidden xl:table-cell" />
            <td>
                <span className={item?.timeCreated ? '' : 'w-3/5 inline-block text-center'}>
                    {GetDate(item?.timeCreated) || '--'} <br />
                    <small>{GetTime(item?.timeCreated)}</small>
                </span>
            </td>
            <td className="text-center capitalize">
                <span className="text-center capitalize">{item?.currency || '--'}</span>
            </td>
            <td className="text-center capitalize">
                {item?.agencyId !== -9191 ? (
                    <span className={item?.tfaEnabled ? 'text-secondary' : 'text-error'}>
                        {item?.tfaEnabled ? 'Enabled' : 'Disabled'}
                    </span>
                ) : (
                    '--'
                )}
            </td>
            <td className="text-center capitalize">
                <span className={isActive ? 'text-secondary' : 'text-warning'}>{item?.status}</span>
            </td>
            <td className="text-center !pr-5">
                <div className="flex flex-row w-full justify-end relative">
                    <OptionButton onClick={handleShowInstMenu} disabled={item?.role === 'temp'} />

                    <InstOption showMenu={showMenu} setShowMenu={setShowMenu}>
                        <Link to={mkRelativeUrl(`/agency/${item?.id}/customers`)} role="button">
                            Manage
                        </Link>

                        {isActive && (
                            <button
                                type="button"
                                onClick={() =>
                                    openModal('UPDATE_AGENCY_INFO_LIST_MODAL', {
                                        id: item?.id,
                                        firstName: item?.firstName,
                                        lastName: item?.lastName,
                                        organization: item?.organization,
                                        primaryEmail: item?.primaryEmail,
                                        primaryPhone: item?.primaryPhone
                                    })
                                }
                                // onClick={() => openModal('update-agency-info-modal', item)}
                            >
                                Edit Info
                            </button>
                        )}
                        <button type="button" onClick={(ev) => handleAgencyStatusModal(ev, item)}>
                            {item?.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        </button>

                        {isActive && (
                            <button
                                type="button"
                                onClick={() =>
                                    openModal('CHANGE_AGENCY_CURRENCY_MODAL', {
                                        agencyId: item?.id || 0,
                                        currency: item?.currency || ''
                                    })
                                }
                            >
                                Change Currency
                            </button>
                        )}

                        {item?.tfaEnabled && isActive && (
                            <button type="button" onClick={handleDisable2FA}>
                                Disable 2FA
                            </button>
                        )}
                        {isActive && (
                            <button
                                type="button"
                                onClick={() => openModal('create-agency-customer-modal', item)}
                            >
                                Create Customer
                            </button>
                        )}
                    </InstOption>
                </div>
            </td>
        </tr>
    );
}

function TableHeader({ handleSortingData, sortedColumn, sortBy }) {
    return (
        <thead>
            <tr>
                <th onClick={() => handleSortingData('id')} scope="col">
                    <span className="uppercase">Id</span>
                    <TableSortArrow name="id" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => handleSortingData('role')} scope="col" className="w-24">
                    <span>Role</span>
                    <TableSortArrow name="role" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th onClick={() => handleSortingData('customer')} scope="col">
                    <span>Name</span>
                    <TableSortArrow name="customer" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col" className="!cursor-default">
                    <span>Email</span>
                </th>
                <th scope="col" className="w-40 !cursor-default hidden xl:table-cell">
                    <span>Application</span>
                </th>
                <th onClick={() => handleSortingData('created')} scope="col" className="w-32 !px-1">
                    <span>Date Created</span>
                    <TableSortArrow name="created" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th
                    onClick={() => handleSortingData('currency')}
                    scope="col"
                    className="w-28 text-center"
                >
                    <span>Currency</span>
                    <TableSortArrow name="currency" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col" className="w-30 text-center !cursor-default">
                    <span>2FA</span>
                </th>
                <th
                    onClick={() => handleSortingData('status')}
                    scope="col"
                    className="text-center w-20 !px-0"
                >
                    <span>Status</span>
                    <TableSortArrow name="status" sortedColumn={sortedColumn} sortBy={sortBy} />
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}

function AgencyPageTableWeb({
    data,
    pagination,
    onChangePage,
    handleSortingData,
    sortedColumn,
    sortBy
}) {
    const [activeId, setActiveId] = useState(-1);

    return (
        <div className="customer_page_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <TableHeader
                    handleSortingData={handleSortingData}
                    sortedColumn={sortedColumn}
                    sortBy={sortBy}
                />
                <tbody className="">
                    {data && data?.length === 0 && (
                        <tr className="border-b border-[#1B1B1F]/10 h-12.5">
                            <td colSpan={10} className="!text-left">
                                <span className="text-primary-700 ">No Customers Found!</span>
                            </td>
                        </tr>
                    )}
                    {data?.map((item) => {
                        const isActive = activeId === item.id;

                        return (
                            <React.Fragment key={item.id}>
                                {/* Agency row */}
                                <TableRow
                                    item={item}
                                    setActiveId={setActiveId}
                                    activeId={activeId}
                                />

                                {/* Agency's customer row */}
                                {isActive &&
                                    item.customerList.map((customer) => (
                                        <TblAgencyCustomerInfo
                                            key={customer.id}
                                            customer={customer}
                                            isActiveAgency={item?.status === 'active'}
                                        />
                                    ))}
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>
            <Pagination data={pagination} onChangePage={onChangePage} />
        </div>
    );
}

export default AgencyPageTableWeb;
